import { render, staticRenderFns } from "./VPNBCDRequestForm.vue?vue&type=template&id=5cdeb226"
import script from "./VPNBCDRequestForm.vue?vue&type=script&lang=js"
export * from "./VPNBCDRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports